import { isUndefined } from 'lodash';
import { fromJS } from 'immutable';
import { getViewInitialState } from 'src/store/view/reducer';
import { TOGGLE_FILTERS_PANEL, TOGGLE_SUBSCRIBE_POPUP } from './constants';

const initialState = fromJS(getViewInitialState());

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_FILTERS_PANEL: {
      const toggleState = action.payload;
      const showSidebar = isUndefined(toggleState)
        ? state.get('hideSidebar')
        : toggleState;
      return state.set('hideSidebar', !showSidebar);
    }
    case TOGGLE_SUBSCRIBE_POPUP: {
      const toggleState = state.get('showSubscribePopup');
      return state.set('showSubscribePopup', !toggleState);
    }
    default:
      return state;
  }
}
